import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { OfferSelectionCardModel, TextModel } from '@flocasts/experience-service-types'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

@Component({
  selector: 'flo-plans-promo-card',
  templateUrl: './plans-promo-card.component.html',
  styleUrls: ['./plans-promo-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlansPromoCardComponent {
  @Input()
  offers: OfferSelectionCardModel[]
  @Input()
  isPlansVariation = true
  @Input()
  sportName: string
  @Output()
  offerSelected = new EventEmitter<OfferSelectionCardModel>()
  @Output()
  signupSelected = new EventEmitter<void>()

  trackById = trackById

  get filteredBullets() {
    return this.offers[0].bulletPoints.filter(
      (bullet: TextModel) => !(bullet.text?.includes('Billed') || bullet.text?.includes('Save'))
    )
  }

  get isPlural() {
    return this.sportName.includes('&') || this.sportName.endsWith('s')
  }

  onOfferSelected(offer: OfferSelectionCardModel): void {
    this.offerSelected.emit(offer)
  }

  onSignupSelected(): void {
    this.signupSelected.emit()
  }

  constructor() {}
}
